import Swiper, { Autoplay, Navigation } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';


window.popupProjectSlide = function popupProjectSlide() {
  let popupProjectSwiperWr = document.querySelectorAll('.popup-project-swiper-wr');

  popupProjectSwiperWr.forEach((el) => {
    if (el) {
      let swiperEl = el.querySelector('.swiper');
      let nextEl = el.querySelector('.swiper-button-next');
      let prevEl = el.querySelector('.swiper-button-prev');
      let slidesCount = el.querySelectorAll('.swiper-slide').length;
      let wrapper = swiperEl.querySelector('.swiper-wrapper');

      let swiper = new Swiper(swiperEl, {
        modules: [Autoplay, Navigation],
        observer: true,
        observeParents: true,
        spaceBetween: 16,
        slidesPerView: 1,
        threshold: 10,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        breakpoints: {

        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: window.innerWidth >= 1033,
        },
      });
      swiperObserver(swiper);
    }
  });
}

popupProjectSlide()
